import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation IntegrationAuthorize(
    $customerId: ID!
    $dataSource: PerformanceCenterDataSource!
    $credentials: CredentialsInput!
  ) {
    integrationAuthorize(
      customerId: $customerId
      dataSource: $dataSource
      credentials: $credentials
    ) {
      id
    }
  }
`;

export const integrationAuthorize = ({ customerId, dataSource, credentials }) => {
  const variables = {
    customerId,
    dataSource,
    credentials,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
